<template>
    <div :class="appliLance">
        <div class="ficheDescriptive-group">
            <div>
                <h2 class="title-ficheDescriptive">Fiche descriptive</h2>
                <hr style="color: white;border-top: solid;">
            </div>


            <div class="container">

                <div class="case">
                    <label><!--<input v-model="confirma" type="checkbox" />--> Num. Dossier</label> 
                    <input v-model="patientCourant['NumDossier']" />
                </div>

                <div class="case">
                    <label>Créé le </label>
                    <input v-model="patientCourant.DateCreation" placeholder="JJ/MM/AAAA" v-date-fr />
                </div>

                <div class="case">
                    <label>Nom </label>
                    <input v-model="patientCourant.Nom" />
                </div>
                <div class="case">
                    <label>Prénom</label>
                    <input v-model="patientCourant.Prenom" />
                </div>

                <div class="case">
                    <label>N.naiss</label>
                    <input v-model="patientCourant.Nnaiss" />
                </div>

                <div class="case">
                    <label>R.g</label>
                    <input v-model="patientCourant.rG" />
                </div>

                <div class="case">
                    <label> Ville</label>
                    <input v-model="patientCourant.Ville" />
                </div>

                <div class="case">
                    <label> C.p.</label>
                    <input v-model="patientCourant.CodePostal" />
                </div>

                <div class="case">
                    <label>
                        Adresse
                    </label>
                    <button @click="ouvrirGoogleMaps"><img src='../images/map.png' alt="map" /></button>
                    <input v-model="patientCourant.Adresse" />
                </div>

                <div class="case">
                    <label>Profession</label>
                    <input v-model="patientCourant.Profession" />
                </div>

                <div class="case">
                    <label>
                        Tél d.
                        <a v-bind:href="'tel:' + patientCourant.TelD">
                            <img src='../images/call.png' alt="tel" />
                        </a>
                    </label>
                    <input v-model="patientCourant.TelD" />
                </div>

                <div class="case">
                    <label>
                        Tél p.<a :href="'tel:' + patientCourant.TelP">
                                  <img src='../images/call.png' alt="tel" />
                        </a>
                    </label>
                    <div class="case">
                        <input v-model="patientCourant.TelP" />
                        <button @click="afficheNumeroMail">@</button>
                    </div>
                </div>

                
                <ul id="listNum">
                    <li>
                        <label>tel3<a :href="'tel:' + patientCourant.Tel3"><img src='../images/call.png' alt="tel" /></a></label>
                        <input v-model="patientCourant.Tel3" />
                    </li>
                    <li>
                        <label>tel4<a :href="'tel:' + patientCourant.Tel4"><img src='../images/call.png' alt="tel" /></a></label>
                        <input v-model="patientCourant.Tel4" />
                    </li>
                    <li>
                        <label>tel5<a :href="'tel:' + patientCourant.Tel5"><img src='../images/call.png' alt="tel" /></a></label>
                        <input v-model="patientCourant.Tel5" />
                    </li>
                    <li>
                        <label>tel6<a :href="'tel:' + patientCourant.Tel6"><img src='../images/call.png' alt="tel" /></a></label>
                        <input v-model="patientCourant.Tel6" />
                    </li>

                </ul>
                
                
                <ul id="listMail">
                    <li>
                        <label>1  <a :href="'mailto:' + patientCourant.Mail1"><img src='../images/email.png' alt="mail" /></a></label>
                        <input v-model="patientCourant.Mail1" />
                    </li>
                    <li>
                        <label>2  <a :href="'mailto:' + patientCourant.Mail2"><img src='../images/email.png' alt="mail" /></a></label>
                        <input v-model="patientCourant.Mail2" />
                    </li>
                    <li>
                        <label>3  <a :href="'mailto:' + patientCourant.Mail3"><img src='../images/email.png' alt="mail" /></a></label>
                        <input v-model="patientCourant.Mail3" />
                    </li>
                    <li>
                        <label>4  <a :href="'mailto:' + patientCourant.Mail4"><img src='../images/email.png' alt="mail" /></a></label>
                        <input v-model="patientCourant.Mail4" />
                    </li>
                </ul>
                
                <div class="case">
                    <label>Date de naissance</label>
                    <input v-model="patientCourant.DateNaissance" placeholder="JJ/MM/AAAA" v-date-fr />
                </div>

                <div class="case">
                    <label>
                        Âge
                    </label>
                    <input v-model="patientCourant.Age" />
                </div>

                <div class="case">
                    <label>Lieu de naissance</label>
                    <input v-model="patientCourant.LieuNaissance" />
                </div>

                <div class="case">
                    <label>Gr.sang.</label>
                    <input v-model="patientCourant.GroupeSanguin" />
                </div>

                <div class="case">
                    <label>Sexe</label>
                    <input v-model="patientCourant.Sexe" />
                </div>

                <div class="case">
                    <label>Titre</label>
                    <input v-model="patientCourant.Titre" />
                </div>

                <div class="case">
                    <label>N°. SS</label>
                    <input v-model="patientCourant.NumSecu" />

                </div>

                <div class="case">
                    <label>Réseau</label>
                    <input type="radio" />
                </div>

            </div>

            <div>
                <div>
                    <label>C</label>
                    <button style="width:100%">Produits F.I.S.I</button>
                </div>

                <div>
                    <textarea class="text-area-ficheDescriptive"></textarea>
                </div>
            </div>

                <div class="Commentaire">
                    <div>
                        <label>Commentaire</label>
                    </div>
                    <textarea v-model="patientCourant.Commentaire" class="text-area-ficheDescriptive"> </textarea>
                </div>
            </div>
    </div>
</template>

<style>
    
    .container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
    }

    .case {
        display: flex;
        margin-bottom: 10px;
        justify-content: space-between; 

    }
    .case label img {
        width: 18px;
        height: 18px;
    }
    .case button img {
        width: 18px;
        height: 18px;
    }
    li label img {
        width:18px;
        height:18px;
    }
    .case label {
        white-space: nowrap;
    }
    .case input {
        width: 200px;
        height: 30px;
        background-color: white
    }
    .case:nth-child(12) input
    {
        margin:0;
        padding:0;
        width:180px;
    }
    li {
        padding: 2px;
        justify-content: space-between;
        display: flex;
    }
    li input {
        width: 200px;
        height: 30px;
    }

    li label {
        margin-right: 10px;
    }

    ul {
        display: none;
        list-style: none;
    }

    .Altyse .ficheDescriptive-group {
        background-color: #E6D5D5;
        border-radius: 30px;
    }

    .Fisimed .ficheDescriptive-group {
        background-color: #00BFFF;
        border-radius: 30px;
    }

    .Fisimed .title-ficheDescriptive {
        background-color: darkblue;
    }

    .Altyse .title-ficheDescriptive {
        background-color: firebrick;
    }

    .title-ficheDescriptive {
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        text-align: center;
        color: white;
        margin-left: auto;
        margin-right: auto;
    }

    .case button {
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background-color: white;
        color: black;
        font-size: 20px;
        border-radius: 20%;
        width: 20px;
        height: 30px;
        cursor: pointer;
    }

    .Altyse .case > label > button:hover {
        padding: 10px;
        background-color: red;
    }

    .Fisimed .case > label > button:hover {
        background-color: cornflowerblue;
    }

    button[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .text-area-ficheDescriptive {
        overflow: scroll;
        width: 100%;
        height: auto;
        padding: 5px;
        border: 1px solid #ccc;
        background-color: white
    }

    .Commentaire {
        padding-bottom: 15px;
        background-color:white
    }

    @media screen and (max-width: 900px) {
        .container {
            grid-template-columns: 1fr;
        }

        .case {
            display: flex;
            margin-bottom: 10px;
            justify-content: space-between;
        }
        .case input {
            width: 150px;
            height: 30px;
        }

        .case:nth-child(12) input {
            margin: 0;
            padding: 0;
            width: 130px;
        }
        li input {
            width: 150px;
            height: 30px;
        }
       
    }

  
</style>

<script>
    import { defineComponent } from 'vue';
    import Patient from '../script/Patient.js';

    export default defineComponent({
        data: function () {
            return {
                uneVariable: 'Je suis la variable',
                confirma : false,
            }
        },

        computed: {
            appliLance() {
                return this.$store.getters["ConnexionStore/getAppliLance"];
            },
            adresseFormatee() {
                return this.patientCourant.Adresse.replace(/ /g, '+')//appliquer le formatage
            },
            urlGoogleMaps() {
                return `https://www.google.fr/maps/place/${this.adresseFormatee},+` + this.patientCourant.CodePostal //retourner l'adresse et le code postal en respectant le formatage
            },
            patientCourantCommentaire() {
                return this.patientCourant.Commentaire
            }
        },

        methods: {
            handleObjetChange() {
                console.log("MODIFIé")
            },
            ouvrirGoogleMaps() {
                window.open(this.urlGoogleMaps, '_blank', 'noreferrer')//blank indique qu'on recharge la page dans une nouvelle fenetre si on veut la charger sur la fenetre actuel utiliser _self et noreferrer pour eviter d'envoyer une requete à notre page car cela la bloqué comme elle ne la traiter pas
            },
            afficheNumeroMail() {

                let listeNum = document.getElementById('listNum');

                let listMail = document.getElementById('listMail');

                if (listeNum.style.display == 'none' && listMail.style.display == 'none') {
                    listeNum.style.display = 'block';
                    listMail.style.display = 'block';
                }
                else {
                    listeNum.style.display = 'none';
                    listMail.style.display = 'none';
                }
            }

        },

        props: ['patientCourant'],
       
    });
</script>
